import { useEffect } from 'react';

type Props = {
  title: string | undefined;
  fallback?: string;
  hideFallback?: boolean;
};

export const useChangeBrowserTabTitleEffect = ({
  title,
  fallback = 'RS',
  hideFallback = false,
}: Props) => {
  useEffect(() => {
    if (title) {
      document.title = hideFallback ? title : `${title} | ${fallback}`;
    } else {
      document.title = fallback;
    }
  }, [fallback, hideFallback, title]);
};
